import { render } from "./AuthenticatorPage.vue?vue&type=template&id=7421f67b&scoped=true"
import script from "./AuthenticatorPage.vue?vue&type=script&lang=js"
export * from "./AuthenticatorPage.vue?vue&type=script&lang=js"

import "./AuthenticatorPage.vue?vue&type=style&index=0&id=7421f67b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7421f67b"]])

export default __exports__